<template>
  <div class="form-container">
    <h1 class="page-title">業者マスタ情報編集</h1>
    <form @submit.prevent="handleSubmit" @keydown.enter.prevent>
      <div class="mb-3">
        <label for="id" class="form-label">ID：</label>
        {{ vendor.id}}
      </div>

      <div class="mb-3">
        <label for="corpNo" class="form-label">法人番号</label>
        <input v-model="vendor.corp_no" type="text" placeholder="法人番号" class="form-control" id="corpNo">
        <div v-if="errorMessages.corp_no" class="alert alert-danger mt-2">{{ errorMessages.corp_no[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="vendorName" class="form-label">業者名 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="vendor.vendor_nm" type="text" placeholder="業者名" class="form-control" id="vendorName" required>
        <div v-if="errorMessages.vendor_nm" class="alert alert-danger mt-2">{{ errorMessages.vendor_nm[0] }}</div>
      </div>

      <PostalCodeInput
        v-model="vendor.postal_code"
        @address="({ region, locality, street }) => {
          vendor.prefecture = region;
          vendor.city = locality;
          vendor.other_address = street;
        }"
      />

      <div class="mb-3">
        <label for="prefecture" class="form-label">都道府県</label>
        <input v-model="vendor.prefecture" type="text" placeholder="都道府県" class="form-control" id="prefecture">
        <div v-if="errorMessages.prefecture" class="alert alert-danger mt-2">{{ errorMessages.prefecture[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="city" class="form-label">市区町村</label>
        <input v-model="vendor.city" type="text" placeholder="市区町村" class="form-control" id="city">
        <div v-if="errorMessages.city" class="alert alert-danger mt-2">{{ errorMessages.city[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="otherAddress" class="form-label">その他の住所</label>
        <input v-model="vendor.other_address" type="text" placeholder="その他の住所" class="form-control" id="otherAddress">
        <div v-if="errorMessages.other_address" class="alert alert-danger mt-2">{{ errorMessages.other_address[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="telNum" class="form-label">メールアドレス</label>
        <input v-model="vendor.email" type="text" placeholder="メールアドレス" class="form-control" id="telNum">
        <div v-if="errorMessages.email" class="alert alert-danger mt-2">{{ errorMessages.email[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="telNum" class="form-label">電話番号</label>
        <input v-model="vendor.tel_num" type="text" placeholder="電話番号" class="form-control" id="telNum">
        <div v-if="errorMessages.tel_num" class="alert alert-danger mt-2">{{ errorMessages.tel_num[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="fax" class="form-label">FAX</label>
        <input v-model="vendor.fax" type="text" placeholder="FAX" class="form-control" id="fax">
        <div v-if="errorMessages.fax" class="alert alert-danger mt-2">{{ errorMessages.fax[0] }}</div>
      </div>

      <div class="btn-area">
        <a class="btn btn-secondary mx-1" @click="$router.back()">戻る</a>
        <button type="submit" class="btn btn-success mx-1">更新</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { getVendor, updateVendor } from '@/api/axios';
import PostalCodeInput from '@/components/shared/PostalCodeInput.vue';

export default {
  components: {
    PostalCodeInput
  },
  setup() {
    const title = ref('業者情報編集');

    watchEffect(() => {
      document.title = title.value;
    });

    const vendor = ref({
      corp_no: '',
      vendor_nm: '',
      postal_code: '',
      prefecture: '',
      city: '',
      other_address: '',
      tel_num: '',
      fax: '',
      // 他のフィールド
    });

    // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const vendorId = route.params.id; // URLから業者情報IDを取得

    const loadVendorData = async () => {
      try {
        const response = await getVendor(vendorId);
        vendor.value = response.data;
      } catch (error) {
        console.error('業者情報データの取得に失敗しました:', error);
      }
    };

    const handleSubmit = async () => {
      try {
        await updateVendor(vendorId, vendor.value);
        store.dispatch('setFlashMessage', {message: '業者情報更新完了！', type: 'success'});
        router.push({
          path: `/vendors/${vendorId}`,
          query: route.query
        });
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        store.dispatch('setFlashMessage', {message: '業者情報更新失敗！', type: 'danger'});
        console.error('更新エラー:', error);
      }
    };

    onMounted(loadVendorData);

    return {
      title,
      vendor,
      handleSubmit,
      errorMessages
    };
  }
};
</script>
